import { Modal, Form } from 'react-bootstrap';
function ParticipantDetailModal({ show, onClose, participant }) {
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Detalles del Participante</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            value={participant.nameParticipant}
                            readOnly
                        />
                    </Form.Group>
                    <Form.Group className="mt-3">
                        <Form.Label>Correo electrónico</Form.Label>
                        <Form.Control
                            as="textarea"
                            value={participant.emailParticipant}
                            readOnly
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Comunidad</Form.Label>
                        <Form.Control
                            value={participant.community}
                            readOnly
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Cuenta MT5</Form.Label>
                        <Form.Control
                            value={participant.idMT5}
                            readOnly
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Clave cuenta MT5</Form.Label>
                        <Form.Control
                            value={participant.passwordMT5}
                            readOnly
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control
                            value={!participant.phone ? 'No proporcionado' : participant.phone}
                            readOnly
                        />
                    </Form.Group>
                    <Form.Group className="mt-3">
                        <Form.Label>Torneo</Form.Label>
                        <Form.Control
                            value={participant.tournament}
                            readOnly
                        />
                    </Form.Group>

                    <div className="mt-4">
                        <div className="row g-3">
                            <div className="col-12 col-md-4">
                                <Form.Group>
                                    <Form.Label>Balance al registrar</Form.Label>
                                    <Form.Control
                                        value={participant.registerBalance || "0.00"}
                                        readOnly
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-12 col-md-4">
                                <Form.Group>
                                    <Form.Label>Balance al iniciar torneo</Form.Label>
                                    <Form.Control
                                        value={participant.initialTournamentBalance || "0.00"}
                                        readOnly
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-12 col-md-4">
                                <Form.Group>
                                    <Form.Label>Balance actual</Form.Label>
                                    <Form.Control
                                        value={participant.currentBalance || "0.00"}
                                        readOnly
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default ParticipantDetailModal;
